import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock, AlertCircle } from "lucide-react";
import { LOGO_URL } from "@/lib/siteData";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(err.message || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-md-bg grid place-items-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="MD Courtage" className="h-20 mx-auto mb-6 object-contain" />
          <h1 className="font-serif text-3xl text-md-primary font-medium">Espace administrateur</h1>
          <p className="text-sm text-md-muted mt-2">Connexion réservée à Maël</p>
        </div>

        <form onSubmit={onSubmit} data-testid="admin-login-form" className="bg-white border border-md-border rounded-3xl shadow-sm p-8 space-y-5">
          <div>
            <label className="text-xs uppercase tracking-widest text-md-accent mb-2 block">Email</label>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-md-bg border border-md-border rounded-xl p-3.5 text-md-text focus:outline-none focus:border-md-secondary"
              autoComplete="email"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-md-accent mb-2 block">Mot de passe</label>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-md-bg border border-md-border rounded-xl p-3.5 text-md-text focus:outline-none focus:border-md-secondary"
              autoComplete="current-password"
            />
          </div>
          {error && (
            <div data-testid="login-error" className="flex items-start gap-2 p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-xl">
              <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
              <span>{error}</span>
            </div>
          )}
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 bg-md-primary hover:bg-md-primaryHover disabled:opacity-50 text-white px-6 py-3.5 rounded-full font-semibold transition-all"
          >
            <Lock className="w-4 h-4" /> {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>

        <p className="text-center text-xs text-md-muted mt-6">
          <a href="/" className="hover:text-md-primary">← Retour au site</a>
        </p>
      </div>
    </div>
  );
}
